import Vue from 'vue'
import Router from 'vue-router'
import Test from './test'
import Menu from './menu'
import Menu_En from './menu_en'

import Home from '@/views/Home.vue'
import Home_En from '@/views/HomeEn.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import PageNotFound from "@/components/PageNotFound";
import InternalServerError from "@/components/InternalServerError";
import MySamples from "@/components/test/Samples";

// UserAgent 분석 라이브러리 - DeclanKim 2025.09.05.sprint1
import { UAParser } from 'ua-parser-js'
import Api from '@/api'

Vue.use(Router)
// 라우트마다 조회수 확인을 위한 설정추가 router.afterEach 를 위해 변수선언 - DeclanKim 2025.09.05.sprint1
const router = new Router({
  mode: 'history',
  routes: [
    ...Test,
    ...Menu,
    ...Menu_En,
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/home',
      name: 'Home-En',
      component: Home_En
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '*',
      redirect: "/404"
    },
    {
      path: '*',
      redirect: "/500"
    },
    {
      path: '*',
      redirect: "/401"
    },
    {
      path: "/404",
      component: PageNotFound
    },
    {
      path: "/500",
      component: InternalServerError
    },
    {
      path: "/401",
      component: MySamples
    }
  ]
})
// 아래는 추가 데이터 수집 코드. DeclanKim 2025.09.05.sprint1

async function getClientIp() {
  try {
    const res = await fetch("https://checkip.amazonaws.com/");
    const ip = (await res.text()).trim(); // 공백/개행 제거
    return ip; // 예: "123.45.67.89"
  } catch (err) {
    console.error("IP 조회 실패:", err);
    return null;
  }
}

let enterTime = null
let currentViewId = null // 서버에서 받은 id 저장

// 라우트 진입 전에 체류시간 계산 및 업데이트
router.beforeEach((to, from, next) => {
  // 새로운 라우트 시작 시간 기록
  enterTime = Date.now();
  currentViewId = null; // 다음 afterEach에서 새 id를 받아올 예정
  next();
})

// 라우트 이동 후 조회수/환경 정보 기록 (INSERT)
router.afterEach(async (to) => {
  const parser = new UAParser();
  const result = parser.getResult();

  const payload = {
    path: to.fullPath,
    browser: result.browser.name,
    browserVersion: result.browser.version,
    cpu: result.cpu.architecture,
    os: result.os.name,
    osVersion: result.os.version,
    device: !result.device
      ? "Desktop"
      : (typeof result.device === "object"
        ? JSON.stringify(result.device)
        : String(result.device)),
    ip: await getClientIp()
  };

  await Api.post(`${process.env.NODE_ENV === 'local' ? "" : process.env.VUE_APP_API_BASE_URL}/api/v1/route/view`, payload)
    .then(res => {
      // 서버에서 새 id를 받아 저장
      currentViewId = res.data.id;
    });
    // 네이버 유입 분석 - DeclanKim 2026.05.19.sprint2
  Vue.nextTick(() => {
    if (window.wcs) {
      window.wcs.inflow();
      window.wcs_do(window._nasa);
    }
  });
})

// 브라우저 종료/새로고침 대비 체류시간 기록
window.addEventListener("beforeunload", async () => {
  if (enterTime && currentViewId) {
    const stayTimeMs = Date.now() - enterTime;
    const payload = {
      id: currentViewId,
      stayTimeMs: stayTimeMs
    };
    await Api.post(`${process.env.NODE_ENV === 'local' ? "" : process.env.VUE_APP_API_BASE_URL}/api/v1/route/stay`, payload);
  }
})

export default router